import httpInstance from '../httpInstance';

const postCreditCardConfig = async (body) => {
  const endpoint = '/back-office/v1/credit-card-config';
  let res;
  await httpInstance.post(
    endpoint,
    body,
  ).then((dataResponse) => {
    res = dataResponse;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default postCreditCardConfig;
